import { PageTitle } from 'components/common/PageTitle/PageTitle';
import { UserDetail } from 'components/employees/UserDetail';
import { SliceStatus } from 'constants/enums/slices';
import { usersPaths } from 'constants/routePaths';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { useEmployeeActions } from 'hooks/useEmployeeActions';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ApiError, User } from './../../types';
import * as Sentry from '@sentry/react';
import { doList as userDoList } from 'store/slices/userSlice';
import { Result, Col, Row, Skeleton, Button } from 'antd';
import notificationHook from 'hooks/notificationHook';
import statusMessages from 'statusMessages';

const UserUploadPage = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const { users, status: userStateStatus } = useAppSelector(
    (state) => state.user
  );
  const [employee, setEmployee] = useState<User | null>();
  const navigate = useNavigate();
  const onDeleteSuccess = useCallback(
    () => navigate(usersPaths.basePath),
    [navigate]
  );
  const employeeActions = useEmployeeActions({ onDeleteSuccess });

  useEffect(() => {
    if (userStateStatus === SliceStatus.Empty) {
      dispatch(userDoList())
        .unwrap()
        .catch((error) => {
          const currentStatus = (error as ApiError).statusCode;
          notificationHook({
            type: 'error',
            message: statusMessages.user[
              currentStatus ? currentStatus : 500
            ] as string,
          });
        });
    } else if (userStateStatus === SliceStatus.Fulfilled && params.id) {
      const currentUser: User | undefined = users.find(
        (c) => c && (c._id === params.id || c.idEmployee === params.id)
      );
      if (currentUser) {
        setEmployee(currentUser);
      } else {
        notificationHook({
          type: 'error',
          message: statusMessages.user[404] as string,
        });
        Sentry.captureMessage('Not able to find a employee to edit');
      }
    }
  }, [params, userStateStatus, dispatch, employee, users]);

  return (
    <>
      <PageTitle>{`Empleado - Detalle`}</PageTitle>
      {userStateStatus === `updating` && (
        <Row>
          <Col xs={24}>
            <Skeleton active />
          </Col>
        </Row>
      )}
      {(userStateStatus === `fulfilled` && employee === null) ||
      userStateStatus === `error` ? (
        <Result
          status="error"
          title="Hubo un error al cargar al empleado"
          subTitle="Por favor vuelve a intentarlo más tarde."
          extra={[
            <Button type="primary" key="back" onClick={() => navigate(-1)}>
              Regresar
            </Button>,
            <Button key="reload" onClick={() => window.location.reload()}>
              Reintentar
            </Button>,
          ]}
        />
      ) : (
        <>
          {userStateStatus === `fulfilled` && employee && (
            <UserDetail
              actions={employeeActions.actions}
              impersonatingEmployeeId={employeeActions.impersonatingEmployeeId}
              user={employee}
            />
          )}
        </>
      )}
    </>
  );
};

export default UserUploadPage;
